module.exports = __webpack_public_path__ + "img/image4.243dcab4.jpeg";